// components/PlusOnesModal.js
// Collects names of plus ones before RSVP is submitted
import React, { useState } from 'react';
import { FiX, FiUser, FiPlus, FiTrash2, FiUsers } from 'react-icons/fi';
import '../styles/Modals.scss';

const PlusOnesModal = ({ maxPlusOnes, onSubmit, onSkip, onClose, eventTitle }) => {
  const [names, setNames] = useState(['']);

  const addName = () => {
    if (names.length < maxPlusOnes) {
      setNames([...names, '']);
    }
  };

  const removeName = (index) => {
    setNames(names.filter((_, i) => i !== index));
  };

  const updateName = (index, value) => {
    const updated = [...names];
    updated[index] = value;
    setNames(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const filledNames = names.map(n => n.trim()).filter(n => n.length > 0);
    onSubmit(filledNames);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content plus-ones-modal" onClick={e => e.stopPropagation()}>

        <div className="modal-header">
          <div className="plus-ones-header-info">
            <FiUsers size={22} className="plus-ones-header-icon" />
            <div>
              <h2>Add Plus Ones</h2>
              {eventTitle && <p className="modal-subtitle">{eventTitle}</p>}
            </div>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            <FiX />
          </button>
        </div>

        <div className="plus-ones-info-banner">
          <p>
            This event allows up to <strong>{maxPlusOnes}</strong> plus one{maxPlusOnes > 1 ? 's' : ''}.
            Add their names so the host knows who's coming.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="plus-ones-form">
          {names.map((name, index) => (
            <div key={index} className="plus-one-row">
              <div className="input-with-icon flex-1">
                <FiUser className="input-icon" />
                <input
                  type="text"
                  placeholder={`Plus one ${index + 1} — full name`}
                  value={name}
                  onChange={e => updateName(index, e.target.value)}
                  maxLength={100}
                  autoFocus={index === 0}
                />
              </div>
              {names.length > 1 && (
                <button
                  type="button"
                  className="remove-plus-one-btn"
                  onClick={() => removeName(index)}
                  aria-label="Remove"
                >
                  <FiTrash2 size={16} />
                </button>
              )}
            </div>
          ))}

          {names.length < maxPlusOnes && (
            <button type="button" className="add-plus-one-btn" onClick={addName}>
              <FiPlus size={16} />
              Add another plus one
            </button>
          )}

          <div className="plus-ones-actions">
            <button type="button" className="btn btn-ghost" onClick={onSkip}>
              Skip (no plus ones)
            </button>
            <button type="submit" className="btn btn-primary">
              Confirm RSVP
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PlusOnesModal;
